import useGetActivityInfo from '@/api/product/useGetActivityInfo';
export default function useActivityInfo() {
    var _a, _b, _c;
    const { data, isLoading } = useGetActivityInfo();
    if (!data)
        return { data: {}, isLoading };
    return {
        diveCenterUrl: data.diveCenter.url,
        titleEn: data.titleEn,
        productType: data.productType,
        breadcrumbs: data.breadcrumbs,
        id: data.id,
        cancellationPolicy: data.cancellationPolicy,
        duration: data.duration,
        groupSize: data.groupSize,
        highlights: data.highlights,
        instantConfirmation: data.instantConfirmation,
        locationTitle: data.locationTitle,
        numberOfDives: data.numberOfDives,
        pickup: data.pickup,
        requirements: data.requirements,
        staffLanguages: data.staffLanguages,
        startTime: data.startTime,
        title: data.title,
        whatToExpect: data.whatToExpect,
        pointsOfInterest: data.pointsOfInterest,
        materials: data.materials,
        priceUsd: data.priceUsd,
        productStandardName: data.standardProductNameEn,
        pictureBackground: data.pictureBackground,
        certificationLevel: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.requirements) === null || _a === void 0 ? void 0 : _a.minCertification) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 10,
    };
}
